import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import {
  Button,
  Row,
  Col,
} from 'react-bootstrap';
import { generate } from 'shortid';
import { format as phoneFormat } from 'libphonenumber-js';

import FieldGroup from '../FieldGroup/FieldGroup';
import EmailField from '../FieldGroup/EmailField';
import PasswordField from '../FieldGroup/PasswordField';

import { SignupFormValidation } from '../../tools/Validations';

import './Auth.css';

const Signup = observer(
class Signup extends Component {
  constructor(props) {
    super(props);
    this.ids = {
      phone: generate(),
      search: generate(),
    };

    this.state = {
      email: "",
      password: "",
      phone: "",
      disableSubmitButton: true,
    };

    this.formValidation = new SignupFormValidation();
    this.formValidation.test(this.state);
  }

  render() {
    return (
      <div className="Signup-container">
        <form onSubmit={this.handleOnSubmit}>
          <EmailField
            focus
            value={this.state.email}
            autoComplete="off"
            validation={this.formValidation.email}
            onChange={this.handleChange} />
          <PasswordField
            value={this.state.password}
            autoComplete="new-password"
            validation={this.formValidation.password}
            onChange={this.handleChange} />
          <FieldGroup
            id={this.ids.phone}
            name="phone"
            type="tel"
            label="Phone"
            value={phoneFormat(this.state.phone, "US", "National")}
            onChange={this.handleChange}
            validation={this.formValidation.phone}
            help="Only Canada and US numbers supported"
            placeholder="e.g. (604) 123-4567" />
          <div className="Signup-terms-text">
            By signing up, you agree to our
            <Link to="/terms" target="_blank"> Terms of Service</Link> and
            <Link to="/privacy" target="_blank"> Privacy Policy</Link>.
          </div>
          <Row>
            <Col xs={3}>
              <Button type="submit" bsStyle="primary" disabled={this.state.disableSubmitButton}>
                Sign up
              </Button>
            </Col>
            <Col xs={9}>
              <div style={{"fontSize": "9pt"}} className="text-danger">{this.props.errorMessage}</div>
            </Col>
          </Row>
        </form>
      </div>
    );
  }

  handleChange = (e, isValid) => {
    let { name, value } = e.target;
    let data = Object.assign({}, this.state);
    data[name] = value;
    data["disableSubmitButton"] = !this.formValidation.test(data);
    this.setState(data);

    const onChange = this.props.onChange;
    if (onChange) {
      onChange(this.state);
    }
    return false;
  }

  handleOnSubmit = (e) => {
    e.preventDefault();

    if (this.formValidation.passAllValidations()) {
      let data = {
        email: this.state.email,
        password: this.state.password,
        phone: this.state.phone,
      };
      let onSubmit = this.props.onSubmit;
      if (onSubmit) {
        onSubmit(data);
      }
    }

    return false;
  }
});

export default Signup;


// WEBPACK FOOTER //
// ./src/components/Auth/Signup.js